import { FormattedMessage } from 'react-intl';

import { ContentArticleStatus } from '@xing-com/crate-common-graphql-types';
import {
  FormattedTimestamp,
  useEditContext,
} from '@xing-com/crate-entity-pages-common';

import type { ArticleCardView } from '../../../types/types';
import { ArticleState } from '../article-state/article-state';
import {
  ArticleCardTopWrapper,
  ButtonsContainer,
  InfoContainer,
} from './article-card-top.styles';
import { EditArticleButton } from './article-controls/article-edit-button';
import { FeatureArticleButton } from './article-controls/article-feature-button';
import { HideArticleButton } from './article-controls/article-hide-button';
import { RemoveArticleButton } from './article-controls/article-remove-button';
import { ShowArticleButton } from './article-controls/article-show-button';
import { UnfeatureArticleButton } from './article-controls/article-unfeature-button';

type Props = {
  article: ArticleCardView;
  ccpId: string;
};

export const ArticleCardTop: React.FC<Props> = ({ article, ccpId }) => {
  const { isEditing } = useEditContext();
  const { publicationState, publishedAt, isFeatured } = article;

  const isPublished = publicationState === ContentArticleStatus.Published;
  const isHidden = publicationState === ContentArticleStatus.Disabled;
  return (
    <ArticleCardTopWrapper>
      <InfoContainer>
        {isEditing ? (
          <span>
            <ArticleState state={publicationState} />
          </span>
        ) : null}
        {publishedAt ? (
          <span>
            <FormattedTimestamp date={new Date(publishedAt)} />
          </span>
        ) : null}
        {isFeatured ? (
          <strong>
            <FormattedMessage id="EP_ARTICLES_MODULE_PINNED_LABEL" />
          </strong>
        ) : null}
      </InfoContainer>
      {isEditing ? (
        <ButtonsContainer>
          {isPublished ? (
            isFeatured ? (
              <UnfeatureArticleButton article={article} />
            ) : (
              <FeatureArticleButton article={article} />
            )
          ) : null}
          <EditArticleButton article={article} ccpId={ccpId} />
          {isPublished ? <HideArticleButton article={article} /> : null}
          {isHidden ? <ShowArticleButton article={article} /> : null}

          <RemoveArticleButton article={article} />
        </ButtonsContainer>
      ) : null}
    </ArticleCardTopWrapper>
  );
};
